import "./extend/object.js";

window.dataView = function(selector, data, settings) {

   let defaults = {
   };

   let set = Object.extend(true, defaults, settings);

   let element = document.querySelector(selector);
   if (element == null) return null;

   element.empty();
   element.classList.add("dataView");

   for (let item of data) {
      element.innerHTML += '<div class="dataView-item"><span class="dataView-label">' + item.label + '</span><span class="dataView-value">' + item.value + '</span></div>';
   }

   return element;

};

if (!HTMLElement.dataView) {
   HTMLElement.prototype.dataView = dataView;
}
